import {BaseContainerModel} from '../base-container.model';
import {app_cfg_main_ext_RowClass} from '../../dbschema/app_cfg_main_ext.model';

export class AppCfgMainExtensionContainerModel extends BaseContainerModel {
  appCfgMainExt: app_cfg_main_ext_RowClass = new app_cfg_main_ext_RowClass();
}
